import React, { useRef, useState } from 'react';
import { useMutation, gql, useQuery } from '@apollo/client';
import { withTranslation } from 'react-i18next';
import {
  Button,
  Box,
  Typography,
  Grid,
  Modal,
  TextField,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Alert,
  Snackbar,
} from '@mui/material';
import useStyles from './styles';
import useStyless from '../Section/styles';
import useGlobalStyles from '../../utils/globalStyles';
import {
  CancelOrder,
  createcsadmin,
  getModifiedOrderDetails,
  modifyorder,
  ProcessOrderRefund
} from '../../apollo';
import DataTable from 'react-data-table-component';
import TableHeader from '../TableHeader';
import CustomLoader from '../Loader/CustomLoader';
import { customStyles } from '../../utils/modifiedOrderTable';

const CREATE_LOCAL_STORE_ADMIN = gql`
  ${createcsadmin}
`;
const EDIT__LOCAL_STORE_ADMIN = gql`
  ${modifyorder}
`;
const EDIT_ORDER_REFUND = gql`
  ${ProcessOrderRefund}
`;
const CANCEL_ORDER = gql`
  ${CancelOrder}
`;
const GET_ORDERDETAILS = gql`
  ${getModifiedOrderDetails}
`;

function ViewEditORderDetails(props) {
  const { onClose, refetch, payMethod, sellingPrice, customerType } = props;
  console.log(props.vendor, 'data from parent ');
  const formRef = useRef();

  const [timeSlotModal, setTimeSlotModalModal] = useState(false);
  const [showCancelOrderModal, setShowCancelOrderModal] = useState(false);
  const userType = JSON.parse(localStorage.getItem('user-native'));
  // REMOVED: const orderId = localStorage.getItem('orderId'); // This line is causing the confusion
  const classess = useStyless();
  const inputTextStyle = { color: 'black' };
  const [formData, setFormData] = useState({
    id: userType._id,
    name: props.vendor ? props.vendor.name : '',
    quantity: props.vendor ? props.vendor.quantity : '',
    instruction: '',
    skuId: props.vendor ? props.vendor.skuId : '',
    productId: props.vendor ? props.vendor.productId : ''
  });

  const [modifiedData, setModifiedData] = useState(props.vendor);
  const [pairs, setPairs] = useState([]);
  const [comment, setComment] = useState('');
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');
  const [openSnack, setOpenSnack] = useState(false);
  console.log(modifiedData, 'modifiedData');
  const orderDetails = JSON.parse(localStorage.getItem('OrderData'));

  const [showProcessRefundConfirmation, setShowProcessRefundConfirmation] = useState(false);
  const [refundMessage, setRefundMessage] = useState('');

  const getPaymentMethod = statusNumber => {
    const statusMap = {
      0: 'COD',
      1: 'ONLINE'
    };

    return statusMap[statusNumber] || 'N/A';
  };

  const { loading: loadingQuery, data } = useQuery(GET_ORDERDETAILS, {
    variables: {
      orderId: orderDetails._id // This correctly uses the ID from OrderData for fetching details
    },
    fetchPolicy: 'no-cache'
  });

  // NEW LINE: Get the orderId directly from the fetched data
  //const currentOrderId = data?.getModifiedOrderDetails?._id;
   const currentOrderId = data && data.getModifiedOrderDetails && data.getModifiedOrderDetails._id;
  console.log(currentOrderId, 'Order ID before refund mutation'); // This will now log the correct ID (e.g., 11871)

  const [modifyOrder] = useMutation(EDIT__LOCAL_STORE_ADMIN, {
    onCompleted: data => {
      setSuccess('Modified Successfully');
      setOpenSnack(true);
      refetch();
      setTimeout(() => onClose(), 2000);
    },
    onError: error => {
      setError(error.message);
      setOpenSnack(true);
    }
  });

  const [isOpen, setIsOpen] = useState(false);

  const handleQuantityChange = (index, value) => {
    if (value < 0 || value > props.vendor[index].quantity) return;
    const updatedData = [...modifiedData];
    updatedData[index].quantity = value;
    setModifiedData(updatedData);
  };

  const getRefundAmount = () => {
    if (!data || !data.getModifiedOrderDetails) return 0;
    return data.getModifiedOrderDetails.refundAmount || 0;
  };

  // Function to initiate the process refund confirmation
  const handleProcessRefundClick = () => {
    setShowProcessRefundConfirmation(true);
  };

  const handleConfirmProcessRefund = async () => {
    setShowProcessRefundConfirmation(false); // Close the confirmation dialog
    try {
      // If payment method is online (1), process the refund
      if (payMethod === 1) {
        const refundAmount = getRefundAmount(); // Function to calculate refund amount

        await processOrderRefund({
          variables: {
            orderId: currentOrderId, // <<< CHANGED from 'orderId' to 'currentOrderId'
            refundAmount,
            reason: 'Refund processed by billing admin',
            isOrderCancelled: parseInt(formData.quantity) === 0
          }
        });

        setSuccess('Refund processed successfully!');
        setOpenSnack(true);
        refetch();
        setTimeout(() => onClose(), 2000);
      }
    } catch (error) {
      setError(error.message || 'Something went wrong!');
      setOpenSnack(true);
    }
  };

  const handleInputChange = e => {
    const { name, value } = e.target;
    if (name === 'quantity' && parseInt(value) > props.vendor.quantity) {
      setError(
        'Please enter a quantity less than or equal to the current quantity.'
      );
      setOpenSnack(true);
      return;
    }
    setFormData({ ...formData, [name]: value });
  };

  const onCompleted = async data => {
    setError('');
    setSuccess('Quantity Updated Successfully');
    setOpenSnack(true);
    refetch();

    if (payMethod && payMethod === 1) {
      await processOrderRefund({
        variables: {
          orderId: currentOrderId, // <<< CHANGED from 'orderId' to 'currentOrderId'
          refundAmount: sellingPrice,
          reason: 'Refund processed by billing admin',
          isOrderCancelled: parseInt(formData.quantity) === 0
        }
      });
    }
  };

  const onError = error => {
    setSuccess('');
    const errorMessage =
      (error && error.graphQLErrors[0] && error.graphQLErrors[0].message) ||
      'Something went wrong!';
    if (errorMessage === 'All items removed!! Please Cancel the Order') {
      setShowCancelOrderModal(true);
    } else {
      setError(errorMessage);
      setOpenSnack(true);
    }
  };

  const [mutate] = useMutation(
    props.vendor ? EDIT__LOCAL_STORE_ADMIN : CREATE_LOCAL_STORE_ADMIN,
    {
      onCompleted,
      onError
    }
  );

  const [processOrderRefund] = useMutation(EDIT_ORDER_REFUND);

  const [cancelOrder] = useMutation(CANCEL_ORDER, {
    onCompleted: data => {
      console.log(
        'i am comming here ',
        data.cancelOrder ? data.cancelOrder : 'nothing'
      );

      if (data.cancelOrder) {
        setError('');
        setSuccess(data.cancelOrder.message);
        setOpenSnack(true);
        setShowCancelOrderModal(false);
        refetch();
        setTimeout(hideAlert, 3000);
      }
    },
    onError: error => {
      setError(error.message || 'Failed to cancel the order');
      setOpenSnack(true);
    }
  });

  console.log('i am comming here ', success, error, openSnack);

  const hideAlert = () => {
    setError('');
    setSuccess('');
    setOpenSnack(false);
    onClose();
  };

  const handleCancelOrder = () => {
    cancelOrder({ variables: { orderId: currentOrderId } }); // <<< CHANGED from 'orderId' to 'currentOrderId'
  };

  const viewmodifieddetails = () => {
    if ((data && data.getModifiedOrderDetails.modifications)) {
      //const parsedData = Object.entries(data.getModifiedOrderDetails.modifications); // Convert JSON to key-value pairs
      //setPairs(parsedData)
      return (JSON.stringify(data.getModifiedOrderDetails.modifications, null, 2));
    }
  };

  const handleCloseSnack = () => {
    setError('');
    setSuccess('');
    setOpenSnack(false);
  };

  const classes = useStyles();
  const globalClasses = useGlobalStyles();

  const getSellingPrice = (prices, customerType) => {
    if (!Array.isArray(prices)) {
      console.error('Invalid prices data:', prices);
      return 'N/A';
    }

    const priceEntry = prices.find(price => price.customerType === customerType);
    return priceEntry ? priceEntry.sellingPrice : 'N/A';
  };

  const modifications =
    (data && data.getModifiedOrderDetails.modifications) || [];

  const formatAmount = value => {
    const amount = Number(value || 0);
    return `Rs. ${amount.toFixed(2)}`;
  };

  const formatModifiedDate = value => {
    if (!value) return 'N/A';
    const date = new Date(value);
    if (Number.isNaN(date.getTime())) return value;
    return date.toLocaleString();
  };

  const getItemKey = item =>
    `${(item && item.productId) || ''}-${(item && item.skuId) || ''}`;

  const getChangedItems = modification => {
    const originalItems = (modification && modification.originalItems) || [];
    const modifiedItems = (modification && modification.modifiedItems) || [];
    const itemKeys = new Set([
      ...originalItems.map(getItemKey),
      ...modifiedItems.map(getItemKey)
    ]);

    return Array.from(itemKeys).map(key => {
      const originalItem = originalItems.find(item => getItemKey(item) === key);
      const modifiedItem = modifiedItems.find(item => getItemKey(item) === key);
      const displayItem = modifiedItem || originalItem || {};
      const originalQty = originalItem ? Number(originalItem.quantity || 0) : 0;
      const modifiedQty = modifiedItem ? Number(modifiedItem.quantity || 0) : 0;

      return {
        key,
        name: displayItem.name || 'N/A',
        skuId: displayItem.skuId || 'N/A',
        unit: [displayItem.measure, displayItem.unit].filter(Boolean).join(' '),
        originalQty,
        modifiedQty,
        quantityDiff: modifiedQty - originalQty,
        sellingPrice: Number(
          (modifiedItem && modifiedItem.sellingPrice) ||
            (originalItem && originalItem.sellingPrice) ||
            0
        ),
        originalTotal:
          originalQty *
          Number((originalItem && originalItem.sellingPrice) || 0),
        modifiedTotal:
          modifiedQty *
          Number((modifiedItem && modifiedItem.sellingPrice) || 0)
      };
    });
  };

  const getBillChanges = modification => {
    const originalBill = (modification && modification.originalBillDetails) || {};
    const modifiedBill = (modification && modification.modifiedBillDetails) || {};
    const billFields = [
      ['itemsTotal', 'Items Total'],
      ['deliveryCharge', 'Delivery Charge'],
      ['handlingCharge', 'Handling Charge'],
      ['couponDiscount', 'Coupon Discount'],
      ['totalSaving', 'Total Saving'],
      ['grandTotal', 'Grand Total'],
      ['refund', 'Refund']
    ];

    return billFields
      .map(([key, label]) => ({
        key,
        label,
        original: originalBill[key],
        modified: modifiedBill[key]
      }))
      .filter(row => row.original !== undefined || row.modified !== undefined);
  };

  // Step 1: Get the first modification's originalItems
  const firstModification = modifications[0] || {};
  const originalItemsMap = new Map();
  ;(firstModification.originalItems || []).forEach(item => {
    originalItemsMap.set(item.productId, item.quantity);
  });

  // Step 2: Get the latest modification's modifiedItems
  const lastModification = modifications[modifications.length - 1] || {};
  const modifiedItemsMap = new Map();
  ;(lastModification.modifiedItems || []).forEach(item => {
    modifiedItemsMap.set(item.productId, item.quantity);
  });

 // Step 3: Create a final list of items with original and modified quantities and prices
const finalItems = Array.from(
  new Set([...originalItemsMap.keys(), ...modifiedItemsMap.keys()])
).map(productId => {
  const modifiedItem = lastModification.modifiedItems
    ? lastModification.modifiedItems.find(
          item => item.productId === productId
      )
    : null;

  const historicalItem = (data && data.getModifiedOrderDetails.items)
    ? data.getModifiedOrderDetails.items.find(
          item => item.productId === productId
      )
    : null;

   return {
  productId,
  name: (modifiedItem && modifiedItem.name) 
    ? modifiedItem.name 
    : (historicalItem && historicalItem.name) 
      ? historicalItem.name 
      : '',
  image: (modifiedItem && modifiedItem.image) 
    ? modifiedItem.image 
    : (historicalItem && historicalItem.image) 
      ? historicalItem.image 
      : '',
  originalQuantity: (originalItemsMap && originalItemsMap.get(productId)) 
    ? originalItemsMap.get(productId) 
    : 0,
  modifiedQuantity: (modifiedItemsMap && modifiedItemsMap.get(productId)) 
    ? modifiedItemsMap.get(productId) 
    : 0,
  mrp: (modifiedItem && modifiedItem.mrp) 
    ? modifiedItem.mrp 
    : (historicalItem && historicalItem.mrp) 
      ? historicalItem.mrp 
      : 0,
  sellingPrice: (historicalItem && historicalItem.sellingPrice) 
    ? historicalItem.sellingPrice 
    : 0,
  prices: (modifiedItem && modifiedItem.prices) 
    ? modifiedItem.prices 
    : (historicalItem && historicalItem.prices) 
      ? historicalItem.prices 
      : []
};

  });

  // Step 4: Define the columns for the table
  const columns = [
    {
      name: 'Sl No',
      selector: (row, index) => index + 1
    },
    {
      name: 'Name',
      selector: row => row.name || 'N/A',
      style: { cursor: 'pointer', minWidth: '200px' }
    },
    {
      name: 'Image',
      cell: row =>
        row.image ? (
          <img src={row.image} alt="Product" style={{ width: 50 }} />
        ) : (
          'N/A'
        )
      // style: { cursor: 'pointer', minWidth: "200px" }
    },
    {
      name: 'Original Quantity',
      selector: row => row.originalQuantity || 0,
      style: { cursor: 'pointer', minWidth: '200px' }
    },
    {
      name: 'Modified Quantity',
      selector: row => row.modifiedQuantity || 0,
      style: { cursor: 'pointer', minWidth: '200px' }
    },
    {
      name: 'MRP',
      selector: row => row.mrp || 0, // Display MRP with default 0
      style: { cursor: 'pointer', minWidth: '200px' }
    },
    {
    name: 'Selling Price',
    cell: (row) => `₹${(row.sellingPrice || 0).toFixed(2)}`, // Use the new sellingPrice field
    style: { cursor: 'pointer', minWidth: '200px' }
  },
  {
    name: 'Net Price',
    cell: (row) => `₹${(row.modifiedQuantity * (row.sellingPrice || 0)).toFixed(2)}`, // Use the new sellingPrice field
    style: { cursor: 'pointer', minWidth: '200px' }
  }
  ];

  const filtered = data && data.getModifiedOrderDetails.items;
  return (
    <>
      <Dialog open={true} onClose={onClose} maxWidth="md" fullWidth>
        <DialogTitle>
          <Box className={classes.heading}>
            <Typography className={classes.textWhite}>
              {props.t('Edit Order Details')}
            </Typography>
          </Box>
        </DialogTitle>
        <DialogContent dividers>
          <Grid container item xs={12} md={6}>
            <Grid item xs={6} md={6}>
              <Typography className={classess.typographyOrder}>
                Original Paid Amount
              </Typography>
            </Grid>
            <Grid item xs={6} md={6}>
              <Typography className={classess.typographyOrder}>
                {data && data.getModifiedOrderDetails
                  ? data.getModifiedOrderDetails.paidAmount
                  : 'N/A'}
              </Typography>
            </Grid>
            <Grid item xs={6} md={6}>
              <Typography className={classess.typographyOrder}>
                Modified Order Amount
              </Typography>
            </Grid>
            <Grid item xs={6} md={6}>
              <Typography className={classess.typographyOrder}>
                {data && data.getModifiedOrderDetails
                  ? data.getModifiedOrderDetails.orderAmount
                  : 'N/A'}
              </Typography>
            </Grid>
            <Grid item xs={6} md={6}>
              <Typography className={classess.typographyOrder}>
                Refund Amount
              </Typography>
            </Grid>
            <Grid item xs={6} md={6}>
              <Typography className={classess.typographyOrder}>
                {data && data.getModifiedOrderDetails
                  ? data.getModifiedOrderDetails.refundAmount
                  : 'N/A'}
              </Typography>
            </Grid>

            <Grid item xs={6} md={6}>
              <Typography className={classess.typographyOrder}>
                Total Refund Proccessed
              </Typography>
            </Grid>
            <Grid item xs={6} md={6}>
              <Typography className={classess.typographyOrder}>
                {data && data.getModifiedOrderDetails
                  ? data.getModifiedOrderDetails.totalRefundProccessed
                  : 'N/A'}
              </Typography>
            </Grid>
            <Grid item xs={6} md={6}>
              <Typography className={classess.typographyOrder}>
                Refund Amount Pending
              </Typography>
            </Grid>
            <Grid item xs={6} md={6}>
              <Typography className={classess.typographyOrder}>
                {data && data.getModifiedOrderDetails
                  ? data.getModifiedOrderDetails.totalRefundPending
                  : 'N/A'}
              </Typography>
            </Grid>
            <Grid item xs={6} md={6}>
              <Typography className={classess.typographyOrder}>
                Payment Method
              </Typography>
            </Grid>
            <Grid item xs={6} md={6}>
              <Typography className={classess.typographyOrder}>
                {data && data.getModifiedOrderDetails
                  ? getPaymentMethod(data.getModifiedOrderDetails.paymentMethod)
                  : 'N/A'}
              </Typography>
            </Grid>
          </Grid>
          <DataTable
            title={<TableHeader title="Orders" />}
            columns={columns}
            data={finalItems}
            pagination
            progressPending={loadingQuery}
            progressComponent={<CustomLoader />}
            customStyles={customStyles}
            // selectableRows
          />
        </DialogContent>
        <DialogActions>
          {data &&
            data.getModifiedOrderDetails && data.getModifiedOrderDetails.orderStatus > 2 && data.getModifiedOrderDetails.items.length === 1 && data.getModifiedOrderDetails.items[0].quantity === 0 ? (
            <Button
              onClick={handleCancelOrder}
              className={globalClasses.dashbordBtn}>
              Cancel order
            </Button>
          ) :
            data &&
              data.getModifiedOrderDetails &&
              data.getModifiedOrderDetails.totalRefundPending > 0 &&
              data.getModifiedOrderDetails.paymentMethod === 1 &&
              data.getModifiedOrderDetails.orderStatus > 2 ? (
              <Button
                onClick={handleProcessRefundClick}
                className={globalClasses.dashbordBtn}>
                Process Refund
              </Button>
            ) : null}
          <Button onClick={() => setShowCancelOrderModal(true)} className={globalClasses.modalCancleBtn}> {/* Changed to call setter directly */}
            View full History
          </Button>
          <Button onClick={onClose} className={globalClasses.modalCancleBtn}>
            Close
          </Button>
        </DialogActions>
        <Snackbar
          open={openSnack}
          autoHideDuration={6000}
          onClose={() => setOpenSnack(false)}>
          {success ? (
            <Alert severity="success">{success}</Alert>
          ) : (
            <Alert severity="error">{error}</Alert>
          )}
        </Snackbar>
      </Dialog>
      {/* Confirmation Modal for Process Refund */}
      <Dialog
        open={showProcessRefundConfirmation}
        onClose={() => setShowProcessRefundConfirmation(false)}
        maxWidth="sm"
        fullWidth
      >
        <DialogTitle>
          <Box className={classes.heading}>
            <Typography className={classes.textWhite}>
              {props.t('Confirm Process Refund')}
            </Typography>
          </Box>
        </DialogTitle>
        <DialogContent dividers>
          <Typography gutterBottom style={{ color: 'black' }}>
            Are you sure you want to process this refund?
          </Typography>

        </DialogContent>
        <DialogActions>
          <Button
            onClick={() => setShowProcessRefundConfirmation(false)}
            className={globalClasses.modalCancleBtn}
          >
            {props.t('No')}
          </Button>
          <Button
            onClick={handleConfirmProcessRefund}
            className={globalClasses.dashbordBtn}
          >
            {props.t('Yes, Process Refund')}
          </Button>
        </DialogActions>
      </Dialog>

      {/* Confirmation Modal */}


      <Dialog
        open={showCancelOrderModal}
        onClose={() => setShowCancelOrderModal(false)}
        maxWidth="md"
        fullWidth>
        <DialogTitle>
          <Box className={classes.heading}>
            <Typography className={classes.textWhite}>
              {props.t('Modified Order History')}
            </Typography>
          </Box>
        </DialogTitle>
        <DialogContent dividers>
          {modifications.length > 0 ? (
            <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
              {modifications.map((modification, index) => {
                const changedItems = getChangedItems(modification);
                const billChanges = getBillChanges(modification);

                return (
                  <Box
                    key={index}
                    sx={{
                      border: '1px solid #e0e0e0',
                      borderRadius: 1,
                      overflow: 'hidden',
                      bgcolor: '#fff'
                    }}>
                    <Box
                      sx={{
                        display: 'flex',
                        justifyContent: 'space-between',
                        alignItems: 'center',
                        gap: 2,
                        bgcolor: '#f5f7ff',
                        borderBottom: '1px solid #e0e0e0',
                        px: 2,
                        py: 1.5,
                        flexWrap: 'wrap'
                      }}>
                      <Box>
                        <Typography
                          sx={{ color: 'black', fontWeight: 700, fontSize: 15 }}>
                          Modification #{index + 1}
                        </Typography>
                        <Typography sx={{ color: '#555', fontSize: 13 }}>
                          {formatModifiedDate(modification.modifiedOn)}
                        </Typography>
                      </Box>
                      <Typography sx={{ color: 'black', fontSize: 13 }}>
                        Modified By: {modification.modifiedBy || 'N/A'}
                      </Typography>
                    </Box>

                    <Box sx={{ p: 2 }}>
                      <Typography
                        sx={{
                          color: 'black',
                          fontWeight: 700,
                          mb: 1
                        }}>
                        Item Changes
                      </Typography>

                      <Box sx={{ overflowX: 'auto' }}>
                        <Box
                          sx={{
                            minWidth: 760,
                            display: 'grid',
                            gridTemplateColumns: '2fr 1fr 1fr 1fr 1fr 1fr',
                            bgcolor: '#f7f7f7',
                            border: '1px solid #e5e5e5'
                          }}>
                          {[
                            'Product',
                            'SKU',
                            'Original Qty',
                            'Modified Qty',
                            'Diff',
                            'Amount'
                          ].map(label => (
                            <Typography
                              key={label}
                              sx={{
                                color: 'black',
                                fontWeight: 700,
                                fontSize: 13,
                                p: 1,
                                borderRight: '1px solid #e5e5e5'
                              }}>
                              {label}
                            </Typography>
                          ))}
                        </Box>

                        {changedItems.map(item => (
                          <Box
                            key={item.key}
                            sx={{
                              minWidth: 760,
                              display: 'grid',
                              gridTemplateColumns: '2fr 1fr 1fr 1fr 1fr 1fr',
                              borderLeft: '1px solid #e5e5e5',
                              borderRight: '1px solid #e5e5e5',
                              borderBottom: '1px solid #e5e5e5'
                            }}>
                            <Typography sx={{ color: 'black', fontSize: 13, p: 1 }}>
                              {item.name}
                              {item.unit ? (
                                <span style={{ color: '#777' }}> ({item.unit})</span>
                              ) : null}
                            </Typography>
                            <Typography sx={{ color: 'black', fontSize: 13, p: 1 }}>
                              {item.skuId}
                            </Typography>
                            <Typography sx={{ color: 'black', fontSize: 13, p: 1 }}>
                              {item.originalQty}
                            </Typography>
                            <Typography sx={{ color: 'black', fontSize: 13, p: 1 }}>
                              {item.modifiedQty}
                            </Typography>
                            <Typography
                              sx={{
                                color:
                                  item.quantityDiff < 0
                                    ? '#d32f2f'
                                    : item.quantityDiff > 0
                                    ? '#2e7d32'
                                    : 'black',
                                fontSize: 13,
                                fontWeight: 700,
                                p: 1
                              }}>
                              {item.quantityDiff > 0 ? '+' : ''}
                              {item.quantityDiff}
                            </Typography>
                            <Typography sx={{ color: 'black', fontSize: 13, p: 1 }}>
                              {formatAmount(item.modifiedTotal)}
                            </Typography>
                          </Box>
                        ))}
                      </Box>

                      <Typography
                        sx={{
                          color: 'black',
                          fontWeight: 700,
                          mt: 2,
                          mb: 1
                        }}>
                        Bill Changes
                      </Typography>

                      <Grid container spacing={1}>
                        {billChanges.map(row => (
                          <Grid item xs={12} sm={6} key={row.key}>
                            <Box
                              sx={{
                                border: '1px solid #e5e5e5',
                                borderRadius: 1,
                                p: 1.25
                              }}>
                              <Typography
                                sx={{ color: '#555', fontSize: 12, fontWeight: 700 }}>
                                {row.label}
                              </Typography>
                              <Typography sx={{ color: 'black', fontSize: 13 }}>
                                {formatAmount(row.original)} {' → '}
                                <b>{formatAmount(row.modified)}</b>
                              </Typography>
                            </Box>
                          </Grid>
                        ))}
                      </Grid>

                      {(modification.refundAmount ||
                        modification.instructions ||
                        modification.isRejected) && (
                        <Box
                          sx={{
                            mt: 2,
                            p: 1.5,
                            border: '1px solid #e5e5e5',
                            borderRadius: 1,
                            bgcolor: '#fafafa'
                          }}>
                          <Typography sx={{ color: 'black', fontSize: 13 }}>
                            <b>Refund:</b> {formatAmount(modification.refundAmount)}
                          </Typography>
                          <Typography sx={{ color: 'black', fontSize: 13 }}>
                            <b>Instructions:</b>{' '}
                            {modification.instructions || 'N/A'}
                          </Typography>
                          {modification.isRejected ? (
                            <Typography sx={{ color: '#d32f2f', fontSize: 13 }}>
                              <b>Rejected:</b>{' '}
                              {modification.rejection &&
                              modification.rejection.reason
                                ? modification.rejection.reason
                                : 'Yes'}
                            </Typography>
                          ) : null}
                        </Box>
                      )}
                    </Box>
                  </Box>
                );
              })}
            </Box>
          ) : (
            <Typography sx={{ color: 'black' }}>
              No modified order history found.
            </Typography>
          )}
        </DialogContent>
        <DialogActions>
          <Button
            onClick={() => setShowCancelOrderModal(false)}
            className={globalClasses.modalCancleBtn}>
            Close
          </Button>
        </DialogActions>
        <Snackbar
          open={openSnack}
          autoHideDuration={6000}
          onClose={handleCloseSnack}
          anchorOrigin={{ vertical: 'top', horizontal: 'center' }}>
          {success ? (
            <Alert
              onClose={handleCloseSnack}
              severity="success"
              variant="filled">
              {success}
            </Alert>
          ) : (
            <Alert onClose={handleCloseSnack} severity="error" variant="filled">
              {error}
            </Alert>
          )}
        </Snackbar>
      </Dialog>

    </>
  );
}

export default withTranslation()(ViewEditORderDetails);
